/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { type FC } from 'react';
import { LabelStyled } from './styled';

export type LabelProps = {
  label: string | any;
  hasDiagram: boolean;
};

const Label: FC<LabelProps> = (props) => {
  const { label, hasDiagram } = props;
  return (
    <LabelStyled className="oss-ui-slider-label" hasDiagram={hasDiagram}>
      {label}
    </LabelStyled>
  );
};

export default Label;
